import ar from '@/local/ar';

export const modalPosition = {
  TOP: 'top',
  MIDDLE: 'middle',
};

export const mode = {
  new: 0,
  update: 1,
  view: 2,
};

export const actionType = {
  serverAction: 1,
  redirect: 2,
  popup: 3,
  redirectToNewTab: 4,
  gridPrinting: 5,
  addNew: 6,
  edit: 7,
  delete: 8,
  view: 9,
  menu: 10,
  exportExcel: 11,
  clone: 12,
};

export const dataType = { dateTime: 1 };

export const httpMethod = {
  GET: 1,
  POST: 2,
  PUT: 3,
  DELETE: 4,
  PATCH: 5,
};

export const countriesEnum = { saudiArabia: 1 };

export const professionTypeEnum = {
  firm: 1,
  company: 2,
  government: 3,
  unEmployed: 4,
  diplomaticAuthority: 5,
};

export const socialIdentityTypeEnum = {
  nationalId: 1,
  regularResidency: 2,
  tempResidency: 3,
  passport: 4,
  without: 5,
  other: 6,
  gulfCountry: 7,
  nationalIdBooklet: 8,
  visitor: 13,
  borderNumber: 14,
  displaced: 15,
  unifiedNumber: 999999997,
  commercialRegistrationNumber: 999999998,
  organizationId: 999999999,
};

export const socialIdTypeEnum = {
  1: 'الهوية الوطنية',
  2: 'إقامة نظامية',
  3: 'إقامة مؤقته',
  4: 'جواز سفر',
  5: 'بدون هوية',
  6: 'أخرى',
  7: 'هوية وطنية خليجية',
  8: 'حفيظة نفوس',
  9: 'بطاقة تنقل وعمل',
  13: 'هوية زائر',
  14: 'رقم الحدود',
  15: 'هوية نازح',
  16: 'هوية معتمر',
  999999997: 'الرقم الوطني الموحد',
  999999998: 'سجل التجاري',
  999999999: 'رقم',
};

export const attachmentType = {
  pdf: 1,
  image: 2,
};

export const userPermission = { reAssignTasks: 80043 };

export const status = [
  {
    id: true,
    name: ar.common.active,
  }, {
    id: false,
    name: ar.common.inactive,
  },
];

export const yesOrNoEnum = {
  yes: 1,
  no: 2,
};
